import React, { useCallback } from 'react'
import { selectAccountId } from '../../../../store/auth/authSlice'
import { useAppDispatch, useAppSelector } from '../../../../store/hooks'
import { selectCrossClientLandingSelectedOwnerId, setCrossClientLandingRunningExecutions } from '../../../../store/crossClient/crossClientLanding'
import { useLazyGetAllCrossClientQueryExecutionsQuery } from '../../../../store/crossClient/crossClient'
import { usePollingEffect } from '../../../../apps/professional-app/fa/common/hooks/usePollingEffect'

const LIST_POLL_INTERVAL_MS = 15_000

export const CrossClientListPoller: React.FC = () => {
  const dispatch = useAppDispatch()

  const accountId = useAppSelector(selectAccountId)
  const selectedOwnerId = useAppSelector(selectCrossClientLandingSelectedOwnerId)

  const [triggerGetAllRunning] = useLazyGetAllCrossClientQueryExecutionsQuery()

  const refreshLists = useCallback(async () => {
    const running = await triggerGetAllRunning({
      accountId,
      hasActiveEvaluations: true,
      expand: ['matches', 'progress', 'evaluationCounts'],
      createdBy: selectedOwnerId ?? undefined,
    }).unwrap()
    dispatch(setCrossClientLandingRunningExecutions(running.data))
  }, [dispatch, accountId, selectedOwnerId, triggerGetAllRunning])

  // leading: false — CrossClientLandingInitialization already does the mount/owner-change fetch, so the
  // first poll tick waits one interval to avoid duplicating that request.
  usePollingEffect(refreshLists, [], { interval: LIST_POLL_INTERVAL_MS, autoStart: true, leading: false })

  return null
}
